import { updateBackupBookingStatus } from "../../../../../../api/backup/backup";

export const UpdateBackupBookingStatusUseCase = async ({
  id,
  bookingStatus,
}) => {
  try {
    const resp = await updateBackupBookingStatus({ id, bookingStatus });
    return resp.data;
  } catch (error) {
    return error.response?.data ?? { message: "error" };
  }
};
